"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var StatusAd = function StatusAd(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.WrapperProductStatus, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.WrapperSubject, {
      adStatus: props.adStatus,
      children: props.subject
    }), props.adStatus !== 'active' && props.adStatus !== 'active_sold' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.WrapperStatusAd, {
      isSelected: props.isSelected,
      className: "wrapper-status",
      children: "Inativo"
    })]
  });
};
var _default = exports["default"] = StatusAd;